import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { generateBlockColorBackgroundProps, generateGradientBackgroundProps, HomepageCardBackgroundGradient } from 'connect-dot-com-ui-components/Components/CUIHomepageCard/utils/backgroundGradients';
import { CUIVStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { trackPageview } from '../utils/usageTracker'; // @ts-expect-error ts-migrate(7016) NOFIX

import profileCardImage from 'bender-url!../../images/homepageCardImages/profile-card.png'; // @ts-expect-error ts-migrate(7016) NOFIX

import academyScreenshots from 'bender-url!../../images/homepageCardImages/academy-screenshots.png'; // @ts-expect-error ts-migrate(7016) NOFIX

import communityUniverse from 'bender-url!../../images/homepageCardImages/community-universe.png'; // @ts-expect-error ts-migrate(7016) NOFIX

import academyBackground from 'bender-url!../../images/homepageCardImages/academy-bg.svg';
import HomepageLayout from './layout/Homepage/HomepageLayout';
import SignupButton from './AuthButtons/SignupButton';
import HomepageCard from './HomepageCard/HomepageCard';
import HomepageCardDescriptionSection from './HomepageCard/HomepageCardDescriptionSection';
import HomepageCardImageSection from './HomepageCard/HomepageCardImageSection';
import HomepageMemberHighlight from './HomepageMemberHighlight/HomepageMemberHighlight';
export default function HomepageContent() {
  useEffect(() => {
    trackPageview('homepage');
  }, []);
  return /*#__PURE__*/_jsx(HomepageLayout, {
    children: /*#__PURE__*/_jsxs(CUIVStack, {
      spacing: 6,
      "data-test-id": "homepage-card-stack",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "HOME_LOAD"
      }), /*#__PURE__*/_jsx(HomepageMemberHighlight, {}), /*#__PURE__*/_jsx(HomepageCard, {
        "data-test-id": "homepage-card",
        mediaSide: "right",
        media: /*#__PURE__*/_jsx(HomepageCardImageSection, Object.assign({
          src: communityUniverse,
          alt: I18n.text('app.homepage.cards.community.imgAlt')
        }, generateBlockColorBackgroundProps())),
        description: /*#__PURE__*/_jsx(HomepageCardDescriptionSection, Object.assign({
          cta: /*#__PURE__*/_jsx(SignupButton, {
            trackingIdentifier: "academy-card"
          }),
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.community.title"
          }),
          bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.community.bodyText"
          })
        }, generateGradientBackgroundProps(HomepageCardBackgroundGradient.cherryBlossomCarnaby, true)))
      }), /*#__PURE__*/_jsx(HomepageCard, {
        "data-test-id": "homepage-card",
        mediaSide: "right",
        media: /*#__PURE__*/_jsx(HomepageCardImageSection, Object.assign({
          src: profileCardImage,
          alt: I18n.text('app.homepage.cards.profile.imgAlt')
        }, generateGradientBackgroundProps(HomepageCardBackgroundGradient.pinkToOrangeishVertical))),
        description: /*#__PURE__*/_jsx(HomepageCardDescriptionSection, Object.assign({
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.profile.title"
          }),
          bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.profile.bodyText"
          }),
          cta: /*#__PURE__*/_jsx(SignupButton, {
            trackingIdentifier: "profile-card"
          })
        }, generateBlockColorBackgroundProps()))
      }), /*#__PURE__*/_jsx(HomepageCard, {
        "data-test-id": "homepage-card",
        mediaSide: "right",
        media: /*#__PURE__*/_jsx(HomepageCardImageSection, Object.assign({
          src: academyScreenshots,
          alt: I18n.text('app.homepage.cards.academy.imgAlt')
        }, generateBlockColorBackgroundProps(academyBackground))),
        description: /*#__PURE__*/_jsx(HomepageCardDescriptionSection, Object.assign({
          cta: /*#__PURE__*/_jsx(SignupButton, {
            trackingIdentifier: "academy-card"
          }),
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.academy.title"
          }),
          bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.academy.bodyText"
          })
        }, generateGradientBackgroundProps(HomepageCardBackgroundGradient.carnabyMacaron, true)))
      })]
    })
  });
}